var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rbTypes"}},_vm._l((_vm.$store.state.initData.rebateType),function(rebateType,index){return _c('TypeItem',{key:index,attrs:{"index":index+'',"rebateTypeName":rebateType['typename'],"selectedBool":_vm.defaultSelectedIndex === index,"currentIndex":index},on:{"itemclick":_vm.itemclick}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2c0f1c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SdkV3/rebate/RebateTypes.vue
// module id = null
// module chunks = 